import React from 'react';
import { Sun, Moon } from '@phosphor-icons/react';
import useTheme from '../hooks/useTheme';

/**
 * Light/dark switch for the app headers.
 *
 * Sized to a 36px touch target and styled for the green WhatsApp header bar,
 * where the surrounding icons are white on #008069.
 */
export default function ThemeToggleButton({ className = '', size = 20 }) {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDark ? 'Light theme' : 'Dark theme'}
      data-testid="theme-toggle-btn"
      className={`flex h-9 w-9 items-center justify-center rounded-full hover:bg-white/10 ${className}`}
    >
      {isDark ? <Sun size={size} weight="bold" /> : <Moon size={size} weight="bold" />}
    </button>
  );
}
